import React from "react";
import { DeviceList } from "../components/devices/DeviceList";
import { VideoPlayer } from "../components/devices/VideoPlayer";

const DevicesPage = ({
    devices,
    selectedDevice,
    onDeviceSelect,
    onDevicePlay,
    playingUrl,
    selectedSubDeviceUrl,
    onSubDeviceSelect,
    selectedSubDeviceLabel,
    onStop,
    extractDeviceName,
}) => {
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

    // Find the currently selected subdevice object
    const selectedSubDevice = React.useMemo(() => {
        if (!selectedDevice || !selectedSubDeviceUrl) return null;
        if (!Array.isArray(selectedDevice.subDevices)) return null;
        return selectedDevice.subDevices.find((sub) => {
            const norm = (u) =>
                typeof u === "string" ? u.replace(/\/+$/, "") : u;
            return norm(sub.url) === norm(selectedSubDeviceUrl);
        });
    }, [selectedDevice, selectedSubDeviceUrl]);

    return (
        <div className="flex flex-1 min-h-0 overflow-hidden">
            <DeviceList
                devices={devices}
                selectedDevice={selectedDevice}
                onDeviceSelect={onDeviceSelect}
                onDevicePlay={onDevicePlay}
                playingUrl={playingUrl}
                selectedSubDeviceUrl={selectedSubDeviceUrl}
                onSubDeviceSelect={onSubDeviceSelect}
                collapsed={sidebarCollapsed}
                onToggleCollapsed={() =>
                    setSidebarCollapsed((collapsed) => !collapsed)
                }
            />

            <VideoPlayer
                deviceBaseUrl={selectedDevice?.url}
                deviceName={
                    selectedDevice
                        ? selectedDevice.label ||
                          extractDeviceName(selectedDevice.url)
                        : ""
                }
                playUrl={playingUrl}
                playing={!!playingUrl}
                onPlay={() => {
                    if (!selectedDevice) return;
                    const urlToPlay =
                        selectedSubDeviceUrl || selectedDevice.url;
                    onDevicePlay(
                        urlToPlay,
                        selectedDevice,
                        selectedSubDeviceLabel,
                    );
                }}
                onStop={onStop}
                selectedSubDeviceLabel={selectedSubDeviceLabel}
                selectedSubDeviceUrl={selectedSubDeviceUrl}
                selectedDevice={selectedDevice}
                selectedSubDevice={selectedSubDevice}
            />
        </div>
    );
};

export default DevicesPage;
